type ThemeColor =
  | "white"
  | "primary"
  | "hero"
  | "primary-text"
  | "primary-light"
  | "secondary-light"
  | "cream"
  | "green-light"
  | "ink"
  | "line";

type SectionDividerProps = {
  from: ThemeColor;
  to: ThemeColor;
  height?: number;
};
export const SectionDivider = ({
  from,
  to,
  height = 10,
}: SectionDividerProps) => {
  return (
    <div
      className=""
      style={{
        height: `${height}px`,
        background: `linear-gradient(
          to bottom,
          var(--color-${from}) 0%,
          var(--color-${to}) 100%
        )`,
      }}
    ></div>
  );
};
